<template>
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.15 12.09a.12.12 0 0 1 0-.175l4.629-4.637a.746.746 0 0 0 0-1.06.754.754 0 0 0-1.06 0L12.09 10.85a.125.125 0 0 1-.18 0L7.281 6.217a.754.754 0 0 0-1.06 0 .746.746 0 0 0 0 1.06l4.63 4.638a.12.12 0 0 1 0 .175l-4.63 4.632a.746.746 0 0 0 0 1.06c.294.29.766.29 1.06 0l4.629-4.632a.125.125 0 0 1 .18 0l4.629 4.633c.294.29.766.29 1.06 0a.746.746 0 0 0 0-1.06l-4.63-4.633Z"
      fill="currentColor"
    />
  </svg>
</template>
